import React, { useState, useEffect } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';

const SectionHero = props => {
  const {
    title,
    listing,
    isOwnListing,
    editParams,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    noPayoutDetailsSetWithOwnListing,
    isIframe = false,
  } = props;

  const [uploadedVideos, setUploadedVideos] = useState([]);
  const [fetchingSignedUrls, setFetchingSignedUrls] = useState(false);

  const hasImages = listing.images && listing.images.length > 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];
  const videos = listing.attributes.publicData.videos || [];

  useEffect(() => {
    if (videos.length > 0 && !fetchingSignedUrls) {
      setFetchingSignedUrls(true);
      const videosWithoutUrl = videos.filter(video => !uploadedVideos.some(v => v.filename === video));

      // Use CloudFront URL for each video that doesn't have url
      videosWithoutUrl.forEach(video => {
        if (video) {
          const cloudfrontUrl = `${process.env.REACT_APP_CLOUDFRONT_URL}/${video}`;
          setUploadedVideos(prevState => [...prevState, { filename: video, url: cloudfrontUrl }]);
        }
      });
      setFetchingSignedUrls(false);
    }
  }, [videos, uploadedVideos]);

  const viewPhotosButton = (hasImages || videos.length > 0) ? (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length + videos.length }}
      />
    </button>
  ) : null;

  const renderMainContent = () => {
    if (videos.length > 0 && uploadedVideos.length > 0) {
      return (
        <video className={css.heroVideo} controls loop muted playsInline autoPlay>
          <source src={uploadedVideos[0].url} type="video/mp4" />
        </video>
      );
    }
    return (
      <ResponsiveImage
        rootClassName={css.rootForImage}
        alt={title}
        image={firstImage}
        variants={variants}
      />
    );
  };

  return (
    <div className={css.sectionHero} data-testid="hero">
      <div className={css.imageWrapperForSectionHero} onClick={handleViewPhotosClick}>
        {listing.id && isOwnListing ? (
          <div onClick={e => e.stopPropagation()} className={css.actionBarContainerForHeroLayout}>
            {noPayoutDetailsSetWithOwnListing ? (
              <ActionBarMaybe
                className={css.actionBarForHeroLayout}
                isOwnListing={isOwnListing}
                listing={listing}
                showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
              />
            ) : null}

            <ActionBarMaybe
              className={css.actionBarForHeroLayout}
              isOwnListing={isOwnListing}
              listing={listing}
              editParams={editParams}
            />
          </div>
        ) : null}

        {renderMainContent()}
        {viewPhotosButton}
      </div>
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={listing.images}
          videos={uploadedVideos}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </div>
  );
};

export default SectionHero;
